import { render, staticRenderFns } from "./provider_main.vue?vue&type=template&id=21a10b34&scoped=true&"
import script from "./provider_main.vue?vue&type=script&lang=js&"
export * from "./provider_main.vue?vue&type=script&lang=js&"
import style0 from "./provider_main.vue?vue&type=style&index=0&id=21a10b34&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21a10b34",
  null
  
)

export default component.exports